import { createContext as o } from "react";
import e from "./en.mjs";
const t = {
  locale: "en",
  localeValues: e
}, c = o(
  t
);
export {
  c as LocaleContext
};
//# sourceMappingURL=context3.mjs.map
